import {debugMode} from '@/constants/environment';
import Captcha from '../Captcha';
declare var turnstile;

export default class TurnstileCaptcha extends Captcha {
  private container: HTMLDivElement;
  private tokenResolver: (token: string) => void;
  private tokenRejector: (error: any) => void;
  private widgetId: string;

  protected getScriptURL(): string {
    return `https://challenges.cloudflare.com/turnstile/v0/api.js?compat=recaptcha`;
  }

  async load(): Promise<void> {
    await this.loadScript();
    await new Promise((resolve) => turnstile.ready(resolve));
    this.createContainer();
    this.widgetId = await this.render();
  }

  private handleTokenCallback(token?: string) {
    if (this.tokenResolver) this.tokenResolver(token);
  }

  private handleErrorCallBack(type, error) {
    if (debugMode()) console.error(type, error);
    if (this.tokenRejector) this.tokenRejector(error);
  }

  private async render(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.tokenRejector = reject;
      // https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#configurations
      const widgetId = turnstile.render(this.container, {
        sitekey: this.getSiteKey(),
        execution: 'execute',
        callback: (token) => this.handleTokenCallback(token),
        'error-callback': (error) => {
          this.handleErrorCallBack('error', error);
        },
        'unsupported-callback': (error) => {
          this.handleErrorCallBack('unsupported', error);
        },
        'expired-callback': (error) => {
          this.handleErrorCallBack('expired', error);
        },
        'timeout-callback': (error) => {
          this.handleErrorCallBack('timeout', error);
        },
      });

      if (widgetId) {
        resolve(widgetId);
      }
    });
  }

  async execute(action?: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.tokenResolver = resolve;
      this.tokenRejector = reject;
      try {
        turnstile.reset(this.widgetId);
      } catch (error) {
        const errorMessage = (typeof error === 'string' ? error : error.message) || '';
        let data = {
          action: 'cbjs_recaptcha_error',
          error_message: errorMessage,
          error_name: error.name,
          hp_step: 'captcha_reset',
          captcha_config: this.options,
        };
        this.options.onError && this.options.onError(data);
      }

      turnstile.execute(this.container, {action});
    });
  }

  private createContainer() {
    let container = document.createElement('div');
    container.id = 'captcha_container';
    container.setAttribute('class', container.id);
    document.body.appendChild(container);
    this.container = container;
  }
}
